/* import "./index.scss"; */
import { __ } from '@wordpress/i18n';
import {Panel, PanelBody, PanelRow, TextControl,Button, TextareaControl, ToggleControl, RadioControl,ToolbarButton, ToolbarGroup} from "@wordpress/components"
import { useBlockProps, useBlockEditContext, BlockControls, InspectorControls, RichText, URLPopover} from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import { useEffect, useState } from '@wordpress/element';
import { Editor } from '@tinymce/tinymce-react';
import metadata from "./block.json";

registerBlockType(metadata.name, {...metadata, edit: EditComponent });

function EditComponent(props) {

	const {attributes, setAttributes}= props;
	const { texto } = attributes;
	

    return (
        <div {...useBlockProps()}>
			<Editor
				apiKey='gfpicx4elp2dejt5nvhi18jjmh0ylnpg7nsclicyboif1pmc'
				value={texto}
				onEditorChange={(e) => setAttributes({texto: e})}
				init={{
					menubar: false,
					plugins: [
						'lists', 'link', 'image', 'charmap', 'textcolor'
					],
					toolbar: 'undo redo | blocks | ' +
						'bold italic underline forecolor backcolor| fontsizeselect | alignleft aligncenter ' +
						'alignright alignjustify | bullist styleselect numlist outdent indent | ' +
						' link image | customButton | removeformat',
					extended_valid_elements: 'button[style|class|onclick|data-*]',
					relative_urls: false, // Mantém os URLs completos
					remove_script_host: false, // Não remove o protocolo e o domínio do URL
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px',
					style_formats: [
						{ title: 'Disco', selector: 'ul', classes: 'disc', styles: { 'list-style-type': 'disc' } },
						{ title: 'Círculo', selector: 'ul', classes: 'circle', styles: { 'list-style-type': 'circle' } },
						{ title: 'Quadrado', selector: 'ul', classes: 'square', styles: { 'list-style-type': 'square' } },
						{ title: 'Sem Formato', selector: 'ul', classes: 'none', styles: { 'list-style-type': 'none' } }
					],
					extended_valid_elements:
						"button[onclick|class|style]"
					,
					// Permite botões com atributos específicos
					setup: function
						(editor) {
						// Adiciona o botão diretamente na toolbar usando addButton no setup
						editor.addButton(
							'customButton', {
							text: 'Botão ficheiro',
							icon: false,
							onclick: function () {
								editor.insertContent(
									'<a href="" class="btn btn-primary btn-sm btn-file">Texto</a>'
								);
							}
						});
					},
					textcolor_map: [
						'595959', 'Black Body',
						'212121', 'Black Heading',
						'701471', 'Primary',
						'b1005d', 'Secondary',
						'FFFFFF', 'White',
						'00FF00', 'Green',
						'0000FF', 'Blue',
						'FF0000', 'Red',
						'FFFF00', 'Yellow',
						'FF00FF', 'Magenta',
						'00FFFF', 'Cyan',
						'F16061', 'Custom Red', // cor personalizada
						'8B4513', 'SaddleBrown', // cor personalizada
					],
					content_style: `
					@import url('https://use.typekit.net/xqp3pmm.css');
					body { 
						color: #595959; 
						font-family: 'ff-dax-pro', sans-serif; 
						font-size: 18px;
					}
					.btn-primary {
						color: #fff;
						background-color: #701471 !important;
						letter-spacing: 1.5px;
						font-size: 14px;
						padding: 1em 3em 1em 2em;
						line-height: 1;
						display: inline-block;
						width: fit-content;
						border-radius: 0.375rem;											
						text-decoration: none;
						position: relative;
					}
					.btn-primary:hover {
						color: #fff;
						background-color: #272727 !important;
					}
					.btn-file[href$=".doc"]:after, .btn-file[href$=".DOC"]:after, .btn-file[href$=".docx"]:after, .btn-file[href$=".DOCX"]:after, .btn-file[href$=".pdf"]:after, .btn-file[href$=".PDF"]:after, .btn-file[href$=".ppt"]:after, .btn-file[href$=".PPT"]:after, .btn-file[href$=".pptx"]:after, .btn-file[href$=".PPTX"]:after, .btn-file[href$=".xls"]:after, .btn-file[href$=".XLS"]:after, .btn-file[href$=".xlsx"]:after, .btn-file[href$=".XLSX"]:after, .btn-file[href$=".zip"]:after, .btn-file[href$=".ZIP"]:after, .btn-file[href$=".rar"]:after, .btn-file[href$=".RAR"]:after {
						content: "";
						position: absolute;
						right: 20px;
						top: 13px;
						height: 15px;
						width: 15px;
						background-repeat: no-repeat;
						filter: invert(1);
					}										
					.btn-file[href$=".doc"]:after, .btn-file[href$=".DOC"]:after, .btn-file[href$=".docx"]:after, .btn-file[href$=".DOCX"]:after {
						content: "" / "Word";
						background-image: url(/wp-content/themes/twentytwentythree-child/assets/img/files-list/file-word.svg);
					}
					.btn-file[href$=".pdf"]:after, .btn-file[href$=".PDF"]:after {
						content: "" / "PDF";
						background-image: url('/wp-content/themes/twentytwentythree-child/assets/img/files-list/file-pdf.svg');
					}
					.btn-file[href$=".xls"]:after, .btn-file[href$=".XLS"]:after, .btn-file[href$=".xlsx"]:after, .btn-file[href$=".XLSX"]:after {
						content: "" / "Excel";
						background-image: url(/wp-content/themes/twentytwentythree-child/assets/img/files-list/file-excel.svg);
					}
					.btn-file[href$=".ppt"]:after, .btn-file[href$=".PPT"]:after, .btn-file[href$=".pptx"]:after, .btn-file[href$=".PPTX"]:after {
						content: "" / "PowerPoint";
						background-image: url(/wp-content/themes/twentytwentythree-child/assets/img/files-list/file-powerpoint.svg);
					}
					.btn-file[href$=".rar"]:after, .btn-file[href$=".RAR"]:after, .btn-file[href$=".zip"]:after, .btn-file[href$=".ZIP"]:after {
						content: "" / "ZIP";
						background-image: url(/wp-content/themes/twentytwentythree-child/assets/img/files-list/file-zip.svg);
					}					
					/* Define os contadores para listas */
					ol { 
						counter-reset: item;
						list-style-type: none;
					}

					ol li { 
						counter-increment: item;
					}

					/* Estilo para os itens principais */
					ol li::before { 
						content: counters(item, ".") ". ";
					}

					/* Estilo para os sub-itens */
					ol ol li::before {
						content: counters(item, ".") " "; /* Numerado como 1.1, 1.2, 2.1, etc. */
					}
					`,
				}}
			/>
        </div>
    );
}
